import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';



export const createLead = createAsyncThunk('sliderLeadBlock/createLead', async (data, thunkAPI) => {
  let campaignCode = '';
  let campaignName = '';
  let productId = '';
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().sliderLeadBlock;
    const authentication = thunkAPI.getState().authentication;

    let campaignCode = state.noFiberCampaignCode;
    let campaignName = state.noFiberCampaignName;
    let productId = state.noFiberProductId;

    const recaptchaToken = '';
    const fullName = `${authentication.loginData.userDetails.firstName} ${authentication.loginData.userDetails.lastName}`;
    const phone = authentication.loginData.userDetails.contactNumber;
    const url = encodeURI(window.location.origin + window.location.pathname);
    const bannerId = '';
    const searchTerm = '';
    const adSource = '';
    const description = '';
    const isAgreementsCheckBoxActive = false;

    const result = await ProviderManager.getProviderData('createLead', [
      recaptchaToken,
      fullName,
      phone,
      campaignCode,
      campaignName,
      productId,
      adSource,
      url,
      bannerId,
      searchTerm,
      isAgreementsCheckBoxActive,
      description
    ]);

    return result;
  } catch (error) {
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'Lead Error - campaignCode : ' + campaignCode + ', campaignName: ' + campaignName + ', productId: ' + productId }));
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {
  noFiberCampaignCode: '',
  noFiberCampaignName: '',
  noFiberProductId: '',
};

const checkFiberInfrastructureSlice = createSlice({
  name: 'sliderLeadBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.noFiberCampaignCode = action.payload.noFiberCampaignCode;
        state.noFiberCampaignName = action.payload.noFiberCampaignName;
        state.noFiberProductId = action.payload.noFiberProductId;
      },
      prepare: (action) => {
        const currentBlock = action.sliderLeadBlock;

        const payload = {
          noFiberCampaignCode: currentBlock.noFiberCampaignCode.value,
          noFiberCampaignName: currentBlock.noFiberCampaignName.value,
          noFiberProductId: currentBlock.noFiberProductId.value
        };
        return { payload: payload };
      }
    },
    reportDWH: (state, action) => { },
  },
  extraReducers: {

  },
});

export const {
  resetBlock,
  initBlock,
  reportDWH,
} = checkFiberInfrastructureSlice.actions;
export default checkFiberInfrastructureSlice.reducer;
